<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MC6cyD/tc-custom/9781466896581.jpg?1737748302626" alt="This image is the cover for the book Bad Characters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bad Characters
      </h1>
      <p class="bookDescription body article font2">
        <p>This book displays at their height the wit, sensibility and psychological penetration that distinguish Miss Stafford's work. There are nine stories and a novella. They range in mood from the title story, a comic portrait of a resourceful child-criminal named Lottie Jump, to "The End of a Career," an elegiac and ironic tale of the declining years of a great beauty. In "A Reasonable Facsimile" Dr. Bohrmann, a retired professor philosophy, is unexpectedly rescued from an aggressively boring young house guest. "Cops and Robbers" is a chilling story of childhood horror and lovelessness that revolves around a father's trip to the barber with his five-year-old daughter.<br/><br/>Several of the stories have as their common setting Miss Stafford's fiction town of Adams, Colorado—including an amusing saga of a girl's frustrated attempts to find a quiet spot to read ("A Reading Problem"), and two stories of failure ("In the Zoo") and success ("The Liberation") in the effort to escape from one's family. "Caveat Emptor" is a satire on the academic life and sub-life at the Alma Hettrick College for Girls; and in "The Captain's Gift" the sheltered and lavender-scented existence of old Mrs. Ramsey is violated by the reality of war.<br/><br/>The major piece in<i> Bad Characters</i> is "A Winter's Tale," a haunting and evocative novella set in Heidelberg just before the outbreak of the war. It is dominated by the diabolic character of Frau Professor Persis Galt. This portrait of a former Bostonian who poses as an excessively devout convert is one of Miss Stafford's most brilliant fictional creations.<br/><br/>This collection by Jean Stafford will be warmly welcomed by the many and devoted admirers of her novels and stories. To new readers the work of one of the best writers of our time will come as a joyful discovery.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean Stafford
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f2592ac0